import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import * as RiIcons from "react-icons/ri";
import { confirmAlert } from "react-confirm-alert";

export const ExportExcel = ({ apiData, fileName }) => {
  const handleExport = () => {
    const worksheetData = [
      [
        "SNo",
        "Delivery Date",
        "Registration Type",
        "Aadhar",
        "RCH ID",
        "IP Number",
        "Patient Name",
        "Mobile No",
        "Infant Status",
        "Infant Count"
      ],
      ...apiData.map((p, i) => [
        i + 1,
        p.patient_created_date,
        p.patient_registration_type,
        p.patient_aadhar,
        p.patient_rchid,
        p.patient_ipnumber,
        p.patient_name,
        p.patient_mobileno,
        p.patient_infant_status,
        p.patient_infant_count
      ])
    ];

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Optional: merge columns (for header only if needed)
   
    ws["!cols"] = new Array(worksheetData[0].length).fill({ wch: 15 });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Patients");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `${fileName}.xlsx`);
  };

  const confirmExport = () => {
    confirmAlert({
      title: "Confirm Export",
      message: "Are you sure you want to export this data to Excel?",
      buttons: [
        { label: "Yes", onClick: handleExport },
        { label: "No" }
      ]
    });
  };

  return (
    <RiIcons.RiFileExcel2Fill
      title="Export to Excel"
      style={{ marginRight: "10px",marginLeft: "10px", color: "#17a2b8", height: 20, width: 20, cursor: "pointer" }}
      onClick={confirmExport}
    />
  );
};